import { Pixels } from '@/themes/variant-interfaces/Pixels';
import { SxProps, Theme } from '@mui/material';

/**
 * Wide enough for the impact and ledger tables without cutting off the points columns, with a
 * booking reserve's ERP id in the wallet column.
 */
export const DETAIL_DIALOG_WIDTH: Pixels = '1280px';

/**
 * For a table that scrolls under a sticky header. The theme's header grey is translucent, so rows
 * would show through it. The theme pads table containers for page cards; inside a dialog that
 * padding only leaves empty margins, and its top would let rows scroll above the header.
 */
export const scrollingTableSx = (maxHeight: number): SxProps<Theme> => ({
  // As specific as the theme's `.MuiTableCell-root.MuiTableCell-head`, or the theme's grey wins.
  '& .MuiTableCell-head.MuiTableCell-stickyHeader': { backgroundColor: 'grey.100' },
  maxHeight,
  p: 0,
});
